import { useEffect, useState } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

// E-mail link target: /pay/invoice/:iid?rail=phonepe|razorpay → resolves the hosted intent then launches that rail.
export default function InvoicePayRedirect({ kind = "invoice" }) {
  const { iid } = useParams();
  const [params] = useSearchParams();
  const { api } = useAuth();
  const nav = useNavigate();
  const [error, setError] = useState("");
  useEffect(() => {
    const rail = params.get("rail") === "razorpay" ? "razorpay" : "phonepe";
    api.get(`/payments/${kind}/${iid}/intent`)
      .then((r) => {
        if (rail === "razorpay" && r.data.razorpay_link) { window.location.replace(r.data.razorpay_link); return; }
        nav(`/pay/${r.data.intent_id}?rail=${rail}`, { replace: true });
      })
      .catch((e) => setError(e?.response?.data?.detail || "This payment link is not available."));
  }, [api, iid, kind, params, nav]);
  return (
    <div className="min-h-screen bg-[#070707] text-[#F5F5F0] grid place-items-center px-6" data-testid="invoice-pay-redirect">
      {error ? <p data-testid="invoice-pay-redirect-error" className="text-[#E08A8A] text-sm">{error}</p>
             : <div className="flex items-center gap-3 text-sm text-[#888]"><Loader2 className="animate-spin text-[#C9A84C]" /> Preparing your secure payment…</div>}
    </div>
  );
}
